module.exports = __webpack_public_path__ + "assets/logo_navbar_old1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_navbar_old1.jpg
 ** module id = 226
 ** module chunks = 1
 **/